import { createSlice } from '@reduxjs/toolkit';

import { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';
import type { OnlineGroupSection } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';
import type { ContentOfType } from 'commonTypes/api/scenarios/scenario';

import { setScenario } from 'entities/scenario';

export interface TimerState {
  remaining: number;
}

const DEFAULT_TIMER_VALUE = 0;

const initialState: TimerState = {
  remaining: DEFAULT_TIMER_VALUE,
};

export const creditTimerSlice = createSlice({
  name: 'creditTimer',
  initialState,
  reducers: {
    tick(state) {
      state.remaining = Math.max(state.remaining - 1, DEFAULT_TIMER_VALUE);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setScenario, (state, { payload }) => {
      if (payload.step === SCENARIO_STEP.CREDIT_SELECTION) {
        const onlineGroup = (payload.content as ContentOfType<SCENARIO_STEP.CREDIT_SELECTION>)?.sections?.find(
          (section) => section.type === 'onlineGroup',
        ) as OnlineGroupSection | undefined;

        state.remaining = onlineGroup?.timerRemainingSeconds ?? DEFAULT_TIMER_VALUE;
        return;
      }

      state.remaining = DEFAULT_TIMER_VALUE;
    });
  },
});

export const { tick } = creditTimerSlice.actions;
